import { normalize } from 'normalizr';
import auth from './auth';

const handleResponse = (resp) => {
  const contentType = resp.headers.get('Content-Type');
  if (contentType) {
    if (contentType.includes('text/html') || contentType.includes('text/plain')) {
      return resp.text();
    }
    return resp.json();
  }
  return resp;
};

const hasErrors = resp => !!resp.errors;

export const get = (url, schema, withCursor = false, params = null) => {
  let targetUrl;
  if (params) {
    targetUrl = new URL(`${url}?`);
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (Array.isArray(value)) {
        value.forEach((item) => {
          targetUrl.searchParams.append(key, item);
        });
      } else {
        targetUrl.searchParams.append(key, value);
      }
      return targetUrl;
    });
  } else {
    targetUrl = `${url}?`;
  }

  return fetch(targetUrl, {
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${auth.getToken()}`,
    },
  })
    .then(res => handleResponse(res))
    .then((response) => {
      if (hasErrors(response)) {
        throw response;
      }

      if (schema) {
        if (withCursor) {
          return {
            data: normalize(response.data.attributes.entities, schema),
            nextPageCursor: response.data.attributes.nextPageCursor,
          };
        }
        return {
          data: normalize(response.data.attributes.entities, schema),
        };
      }
      return response;
    })
    .catch((err) => { throw err; });
};

export const post = (url, body = {}, options = {}) => fetch(url, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    authorization: `Bearer ${auth.getToken()}`,
  },
  body: JSON.stringify(body),
  ...options,
})
  .then(res => handleResponse(res))
  .then((response) => {
    if (hasErrors(response)) {
      throw response;
    }
    return response;
  })
  .catch((err) => { throw err; });

export const postNoAuth = (url, body = {}, options = {}) => fetch(url, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify(body),
  ...options,
})
  .then(res => handleResponse(res))
  .then(response => response)
  .catch(err => err);

export const update = (url, body = {}, options = {}, schema) => fetch(url, {
  method: 'PATCH',
  headers: {
    'Content-Type': 'application/json',
    authorization: `Bearer ${auth.getToken()}`,
  },
  body: JSON.stringify(body),
  ...options,
})
  .then(res => handleResponse(res))
  .then((response) => {
    if (hasErrors(response)) {
      throw response;
    }

    if (schema) {
      return {
        data: normalize(response.data.attributes.entities, schema),
      };
    }
    return response;
  })
  .catch((err) => { throw err; });

export const deleteEntity = (url, options = {}) => fetch(url, {
  method: 'DELETE',
  headers: {
    authorization: `Bearer ${auth.getToken()}`,
  },
  ...options,
})
  .then(res => handleResponse(res))
  .then((response) => {
    if (hasErrors(response)) {
      throw response;
    }
    return response;
  })
  .catch((err) => { throw err; });



// WEBPACK FOOTER //
// ./src/utils/communications.js